
export type SecurityClearance =
    "UnauthenticatedClients"
    | "ClusterAdmin"
    | "ClusterNode"
    | "Operator"
    | "ValidUser";
